<template functional>

    <span v-if="props.auto_sent" class="message-header-data">

        <!-- Sent by Automation (greeting) -->
        <template v-if="props.auto_sent === 'automation'">
            <span v-b-tooltip.hover :title="parent.$t('simple.auto_sent_automation')">
                <font-awesome-icon :icon="'cogs'" class="text-success" />
            </span>
        </template>

        <!-- Sent by Campaign -->
        <template v-else-if="props.auto_sent === 'campaign'">
            <span v-b-tooltip.hover :title="parent.$t('simple.auto_sent_campaign')">
                <font-awesome-icon :icon="'cogs'" />
            </span>
        </template>

    </span>

</template>

<script>

    export default {

    }

</script>